/*@ngInject*/
export function WixResponseInterceptor($q) {
    // tslint:disable-next-line:no-invalid-this
    var that = this;
    // tslint:disable-next-line:no-invalid-this
    that.response = function (response) {
        var data = response.data;
        var isWixResponse = (data.payload || data.errorCode || data.errorDescription) && data.success !== undefined;
        if (isWixResponse) {
            var success = data.success;
            if (!success) {
                return $q.reject(response);
            }
            else {
                response.data = data.payload;
            }
        }
        // tslint:disable-next-line:no-invalid-this
        return response || this.$q.when(response);
    };
}
//# sourceMappingURL=wix-response-interceptor.srv.js.map